import React from "react";
import Icon from "../Icon/Icon";

import styles from "./AuthDrawer.css";

var ForgotPasswordTwo = function ForgotPasswordTwo() {
  return React.createElement(
    "div",
    { className: styles.container },
    React.createElement(
      "div",
      { className: styles.textCenter },
      React.createElement(Icon, { className: styles.checkmark, name: "check/rounded" })
    ),
    React.createElement(
      "h3",
      { className: styles.marginTop20 },
      "Email sent!"
    ),
    React.createElement(
      "div",
      { className: styles.marginTop20 },
      "You should receive instructions on resetting your password shortly. If you don't receive an email, please make sure you've entered the address you've registered, and check your spam folder."
    )
  );
};

export default ForgotPasswordTwo;


// WEBPACK FOOTER //
// ./src/components/Library/AuthDrawer/ForgotPasswordTwo.js